import { Box } from '@mui/material'
import { SchedulerTabsProps } from './Scheduler.types'
import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerBaseMaterialCleanChangeoverTable } from './SchedulerBaseMaterialCleanChangeover.muiTable'

export const ScheduleBaseMaterialCleanChangeover = ({
  schedulerId,
  iteration,
}: SchedulerTabsProps) => {
  const API = 'base-material-clean-changeover'
  const { data: responseData = { data: [], predicate: undefined }, isLoading } =
    useScheduleProductionRequirements(schedulerId, API, iteration)
  const { data = [], predicate } = responseData

  const {
    updateTableData,
    uploadScheduleData,
    deleteTableData,
    isSaving,
    isUploading,
    isDeleting,
    updateRowsStatus,
  } = useSchedulerTableHandlers(schedulerId, API, iteration)

  return (
    <Box sx={{ height: 'calc(100vh - 240px)', minHeight: 400 }}>
      <SchedulerBaseMaterialCleanChangeoverTable
        data={data}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadScheduleData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        updateRowsStatus={updateRowsStatus}
        predicate={predicate}
        deleteTableData={deleteTableData}
        isDeleting={isDeleting}
      />
    </Box>
  )
}
